import { ApolloClient } from '@apollo/client';

export interface DataProviderResult {
  data: any;
  total?: number;
}

export interface DataProviderParams {
  pagination?: {
    page: number;
    perPage: number;
  };
  sort?: {
    field: string;
    order: 'ASC' | 'DESC';
  };
  filter?: any;
  id?: string;
  ids?: string[];
  data?: any;
}

export abstract class BaseDataProvider {
  protected client: ApolloClient<any>;

  constructor(client: ApolloClient<any>) {
    this.client = client;
  }

  abstract getList(resource: string, params: DataProviderParams): Promise<DataProviderResult>;
  abstract getOne(resource: string, params: DataProviderParams): Promise<DataProviderResult>;
  abstract create(resource: string, params: DataProviderParams): Promise<DataProviderResult>;
  abstract update(resource: string, params: DataProviderParams): Promise<DataProviderResult>;
  abstract delete(resource: string, params: DataProviderParams): Promise<DataProviderResult>;

  // Общие методы
  getMany(resource: string, params: DataProviderParams): Promise<DataProviderResult> {
    return Promise.resolve({ data: [] });
  }

  getManyReference(resource: string, params: DataProviderParams): Promise<DataProviderResult> {
    return Promise.resolve({ data: [], total: 0 });
  }

  updateMany(resource: string, params: DataProviderParams): Promise<DataProviderResult> {
    console.log('UpdateMany not implemented yet:', resource, params);
    return Promise.resolve({ data: params.ids || [] });
  }

  deleteMany(resource: string, params: DataProviderParams): Promise<DataProviderResult> {
    console.log('DeleteMany not implemented yet:', resource, params);
    return Promise.resolve({ data: params.ids || [] });
  }

  protected logError(resource: string, operation: string, error: any, params?: any) {
    console.error(`❌ [DataProvider] ${operation} Error for ${resource}:`, {
      resource,
      operation,
      params,
      error: error.message,
      networkError: error.networkError?.message,
      graphQLErrors: error.graphQLErrors?.map((e: any) => e.message),
    });
  }

  protected logSuccess(resource: string, operation: string, data: any) {
    console.log(`✅ [DataProvider] ${operation} Success for ${resource}:`, data);
  }

  protected logInfo(resource: string, operation: string, params: any) {
    console.log(`🔍 [DataProvider] ${operation} ${resource}:`, params);
  }
}
